import { BootstrapBrowserBuilder } from '@zg-rentals/rp-bootstrap-browser';
import { analytics } from '../analytics';

const appName = 'zrm-marketing-web';

const builder = new BootstrapBrowserBuilder(appName, Number(process.env.BUILD_NUMBER))
  .withHostedAppLoggerOptions('rental-manager-api', process.env.NEXT_PUBLIC_LOG_LEVEL)
  // even though clickstream is already initialized via page frame service for this app
  // the analytics module already accounts for checking that and we may have other init
  // side effects in the future we want all apps to have; still init analytics for this app
  // it does not matter which clickstream code initializes first
  .withOnRegister(analytics.initialize);

if (process.env.NEXT_PUBLIC_DD_APP_ID && process.env.NEXT_PUBLIC_DD_CLIENT_TOKEN) {
  builder.withDatadogPlugin(process.env.NEXT_PUBLIC_DD_APP_ID!, process.env.NEXT_PUBLIC_DD_CLIENT_TOKEN!);
}

export const bootstrap = builder.build();
